import React from 'react';
import config from '../config'
const cdnpath = config.cdnpath

const RateOutFitCardStack = (props) => {

const selectedTags = props.selectedTags


if(!selectedTags || selectedTags.length === 0){
 return (
  <div className="page">
    <div className="fineryCardContainer">
      <div className="fineryCardFake"></div>
      {props.children}
    </div>
    <div className={`fineryStickerCard ${ props.visibleClass }`} onClick={ props.onClickHandler }>
    <div><img className="buttonStickers"  src={`${cdnpath}/images/stickers/stickers-19.png`} /><img className="buttonStickers" src={`${cdnpath}/images/stickers/stickers-21.png`} /><img className="buttonStickers"  src={`${cdnpath}/images/stickers/stickers-14.png`} /><img className="buttonStickers" src={`${cdnpath}/images/stickers/stickers-13.png`} /><img className="buttonStickers" src={`${cdnpath}/images/stickers/stickers-18.png`} /><img className="buttonStickers" src={`${cdnpath}/images/stickers/stickers-06.png`} /></div>
    add stickers
    </div>

  </div>
  )
}else{

  const selectedTagsList = selectedTags.map((tag) => {
    const style = { backgroundImage: `url(${tag.src})` }
    return (
      <div key={tag.label} className="selectedTag" style={style } />
      )
    })

  return (
    <div className="page">
      <div className="fineryCardContainer">
        <div className="fineryCardFake"></div>
        {props.children}
      </div>
      <div className={`fineryStickerCard tagSelectedBar ${ props.visibleClass }`} onClick={ props.onClickHandler }>
      {selectedTagsList}
      </div>

    </div>
  )
}

}
export default RateOutFitCardStack;



// WEBPACK FOOTER //
// ./src/templates/RateOutFitCardStack.js